module.exports = __webpack_public_path__ + "static/media/sign-check.0dbe3640.png";